import classNames from 'classnames';
import Image from 'next/image';
import React from 'react';
import styles from './design-visual.module.css';

import products from '../../public/design/visual/apps-min.png';
import apps from '../../public/design/visual/frame.png';
import s1 from '../../public/design/visual/7.png';
import s2 from '../../public/design/visual/8.png';
import s3 from '../../public/design/visual/9.png';
import { Container } from '../../components';

export default function DesignVisual() {
  return (
    <section className={styles.root}>
      <Container>
        <h2 className={styles.title} id="visual">
          Visual Design
        </h2>
        <div className={styles.row}>
          <p className={styles.text}>
            When the logic and the brand are ready, let&apos;s take the paints
            in hands and add colors to our wireframes.
            <br />
            <br />
            At this stage, we work on the creation of the modern, trendy design
            based on the brand identity that we already have. Black and white
            wireframes come to life with fonts, shadows and colours,
            demonstrating the final picture.
          </p>
          <div className={styles.box}>
            <span className={styles.counter}>04</span>
            <span className={styles.subtitle}>Sketching</span>
          </div>
        </div>
      </Container>
      <div className={styles.gallery}>
        <div className={styles.galleryContainer}>
          <Image
            alt="design products list"
            src={products}
            width={2926}
            height={1792}
          />
        </div>
      </div>
      <div className={styles.steps}>
        <span className={classNames(styles['step-counter'], styles.first)}>
          1
        </span>
        <div className={styles.desc}>
          <Image
            alt="dashed stepline"
            src="/design/stepline1.png"
            layout="fill"
          />
        </div>
        <div className={styles.mob}>
          <Image
            alt="mobile dashed stepline"
            src="/design/stepline1-mob.png"
            layout="fill"
          />
        </div>
        <span className={classNames(styles['step-counter'], styles.second)}>
          2
        </span>
      </div>

      <div className={styles.apps}>
        <div className={styles.gradiend} />
        <div className={styles.background} />
        <Container>
          <Image
            alt="music player app prototype"
            src={apps}
            width={1450}
            height={849}
          />
        </Container>
      </div>

      <div className={styles.steps}>
        <span className={classNames(styles['step-counter'], styles.third)}>
          2
        </span>
        <div className={styles.desc}>
          <Image
            alt="dashed stepline"
            src="/design/stepline2.png"
            layout="fill"
          />
        </div>
        <div className={styles.mob}>
          <Image
            alt="mobile dashed stepline"
            src="/design/stepline2-mob.png"
            layout="fill"
          />
        </div>

        <span className={classNames(styles['step-counter'], styles.fourth)}>
          3
        </span>
      </div>

      <div className={styles.challanges}>
        <Container>
          <div className={styles['list-challanges']}>
            <div className={styles.yoga}>
              <Image
                alt="In-app yoga challenge progress design"
                src={s1}
                width={375}
                height={812}
              />
            </div>
            <div className={styles.yoga}>
              <Image
                alt="In-app yoga challenge info design"
                src={s2}
                className={styles.yoga}
                width={375}
                height={812}
              />
            </div>

            <div className={styles.yoga}>
              <Image
                alt="In-app yoga challenge start design"
                src={s3}
                className={styles.yoga}
                width={375}
                height={812}
              />
            </div>
          </div>
        </Container>
      </div>
    </section>
  );
}
